<script lang="ts" setup>
defineProps<{
  id?: string;
  icon?: string;
  active?: boolean;
  disabled?: boolean;
}>();
const emit = defineEmits<{
  (e: "click", event: Event): void;
}>();

function onClick(e: Event) {
  emit("click", e);
}
const textDiv = ref<HTMLDivElement>();
</script>

<template>
  <li class="flex w-full flex-row flex-nowrap items-center justify-between">
    <button
      :id="id"
      :class="{ active: active, disabled: disabled }"
      type="button"
      class="dropdown-item toolbar-button-dropdown-item flex-1"
      @click="onClick"
    >
      <FAIcon
        v-if="icon"
        :class="`fa-light ${icon} fa-fw`"
      />
      <div
        ref="textDiv"
        class="text"
        :title="textDiv?.innerText"
      >
        <slot />
      </div>
      <FAIcon
        v-if="active"
        class="fa-light fa-check fa-fw ml-auto"
      />
    </button>
    <slot
      v-if="!disabled"
      name="end"
    >
    </slot>
  </li>
</template>

<style scoped lang="postcss">
/* .active-toolbar-button {
   @apply bg-primary text-white whitespace-nowrap;
 }*/
.text {
  @apply line-clamp-1;
}
.dropdown-item {
  i,
  svg {
    @apply text-primary;
  }
}
</style>
